module.exports = __webpack_public_path__ + "img/Bitte auswählen.d41d8cd9.svg";